<script setup lang="ts">
export interface NimbusBlogProseAProps {
    href?: string
}

defineProps<NimbusBlogProseAProps>()
</script>

<template>
    <NuxtLink v-if="href" :to="href">
        <slot />
    </NuxtLink>
    <slot v-else />
</template>
